<template>
<v-form ref="formSelect">
  <v-select
      v-model="item"
      :items="items"
      :label="itemAction.name"
      :item-text="itemText"
      :item-value="(itemAction.value)? itemAction.value : 'id'"
      clearable
      outlined
      dense>
  </v-select>
</v-form>

</template>

<script>
import axios from 'axios'
import { HeaderGral } from '@/store/modules/config'
export default {
  props: ['itemAction', 'onSuccess', 'onError', 'setterModel'],
  data: () => ({
    item: null,
    items: []
  }),
  created () {
    if (this.itemAction.url) {
      if (this.itemAction.post) {
        this.postDinamicData(this.itemAction.url)
        return
      }
      this.getDinamicData(this.itemAction.url)
    }
  },
  methods: {
    itemText (item) {
      if (item && this.itemAction.nameid === 'plazo') {
        return `${item.plazo}`
      } else if (item && this.itemAction.nameid === 'rol_id') {
        return `${item.nombre}`
      }
      return 'No Title'
    },
    getDinamicData (url) {
      const header = HeaderGral()
      axios.get(url, header).then(response => {
        this.items = []
        this.items.push(...response.data)
        // this.setModel(this.items)
        if (this.items.length <= 0) {
          if (this.onError) this.onError(this.itemAction)
        }
      }).catch(error => {
        console.log('error', error)
        if (error == null) {
        }
      })
    },
    postDinamicData (url) {
      const header = HeaderGral()
      axios.post(url, this.itemAction.data, header)
        .then(response => {
          this.items = []
          this.items.push(...response.data)
          if (this.items.length <= 0) {
            if (this.onError) this.onError(this.itemAction)
          }
        })
        .catch(error => {
          console.log('error', error)
          if (error == null) {
          }
        })
    },
    setModel (vals) {
      vals.map(i => {
        if (this.setterModel === i.id) {
          this.item = i
        }
      })
    }
  },
  computed: {
  },
  watch: {
    item (val) {
      this.onSuccess({ id: this.itemAction.nameid, data: val })
    },
    items (vals) {
      if (this.setterModel) {
        this.item = this.setterModel
      }
    }
  }
}
</script>

<style>
</style>
